function getFieldErrorId(fieldName: string) {
  return `${fieldName}-error`;
}

export { getFieldErrorId };
